import React from 'react'
import { Box } from '@mui/material'

const DartIcon = ({ sx = {} }) => {
  const { fontSize = 20, flexShrink, ...restSx } = sx
  return (
    <Box
      component="span"
      role="img"
      aria-label="dart"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize,
        lineHeight: 1,
        flexShrink: flexShrink ?? 0,
        filter: 'grayscale(1)',
        ...restSx
      }}
    >
      🎯
    </Box>
  )
}

export default DartIcon
